module.exports = __webpack_public_path__ + "img/705.d78a0cc3.jpg";